/**
 * 产品评分 block — 点击平滑滚动到评论区。
 *
 * 由 sections/main-product.liquid 按需加载。
 */
(function () {
  "use strict";

  if (window.__productBlockRatingBound) return;
  window.__productBlockRatingBound = true;

  document.addEventListener("click", function (event) {
    var link = event.target.closest(".main-product .product-block-rating__link");
    if (!link) return;

    var href = link.getAttribute("href");
    if (!href || href.charAt(0) !== "#") return;

    var target = document.querySelector(href);
    if (!target) return;

    event.preventDefault();
    window.scrollTo({
      top: target.getBoundingClientRect().top + window.pageYOffset,
      behavior: "smooth",
    });
  });
})();
